import { pgTable, serial, integer, boolean, timestamp } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const notificationSettingsTable = pgTable("notification_settings", {
  id: serial("id").primaryKey(),
  companyId: integer("company_id").notNull().unique(),
  deadlineReminder7Days: boolean("deadline_reminder_7_days").notNull().default(true),
  deadlineReminder1Day: boolean("deadline_reminder_1_day").notNull().default(true),
  analysisComplete: boolean("analysis_complete").notNull().default(true),
  subscriptionEvents: boolean("subscription_events").notNull().default(true),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export const insertNotificationSettingsSchema = createInsertSchema(notificationSettingsTable).omit({ id: true, createdAt: true, updatedAt: true });
export type InsertNotificationSettings = z.infer<typeof insertNotificationSettingsSchema>;
export type NotificationSettings = typeof notificationSettingsTable.$inferSelect;
